<script>
export default {
  props: {
    item: {type: Object},
    isVertical: {type: Boolean, default: true},
    isCountryVisible: {type: Boolean, default: true}
  },
}
</script>
<template>
  <div>
    <div v-if="isVertical">
      <span v-if="item.recipient">
        {{ item.recipient && item.recipient }}<br>
      </span>
      <span>
        {{ item.street }} {{ item.houseNumber }}<br>
      </span>
      <span>
        {{ item.zipCode }} {{ item.city }}<br>
      </span>
      <span v-if="isCountryVisible">
        {{ item.country }}
      </span>
    </div>
    <div v-else>
      <span v-if="item.recipient">
        {{ item.recipient && item.recipient }},
      </span>
      <span>
        {{ item.street }} {{ item.houseNumber }},
      </span>
      <span>
        {{ item.zipCode }} {{ item.city }}
      </span>
    </div>
  </div>
</template>
